RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.EmailTab = RivalIQ.views.LayoutView.extend({
        regions: {
            email: '.x-notification-email',
            settings: '.x-notification-settings'
        },
        template: '#emailTabTemplate',
        // NOTE we have to load data way up stream because the host application
        // is, at this point, "legacy," and does not work how the rest of the
        // product works
        loadData: function () {
            return $.when.call();
        },
        onBeforeRenderLoaded: function () {
            const me = this;
            me.showList();
            me.showSettings();
        },
        showList: function () {
            const me = this;
            const options = me.options;

            const email = new App.views.EmailList({
                model: new Backbone.Model(_.pick(options, 'email')),
                collection: options.landscapeEmails
            });

            me.email.show(email);
        },
        showSettings: function () {
            const me = this;

            const settings = new App.views.Settings({
                collection: me.options.settings
            });

            me.settings.show(settings);
        }
    });

});
